import { PropTypes } from 'prop-types';
// Removing imports for MVP0 - Story #417
import React from 'react'; // , useState } from 'react';
// import { useTranslation } from 'react-i18next';
import styled, { withTheme } from 'styled-components';

// Removing for MVP0 - Story #417
// import { Select } from '@ge/components/select';
import { Loader } from '@ge/components/loader';
import { MobileAssetTab } from '@ge/models/constants';
import { SortDirection } from '@ge/components/table/models/sort-direction';
import { useColumnState } from '@ge/components/table/use-column-state';
import { useAssetRealTimeData } from '@ge/shared/data-hooks';

import AssetRealtimeInfo from './live-reading';
import AssetActiveAlarmInfo from './active-alarm'

export const SiteLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  &.hidden {
    display: none;
  }
`;
const TurbineContentWrapper = styled.div`
  &.hidden {
    display: none;
  }
`;
const EventMetric = {
  START: 'start',
};
const AssetDetails = ({ assetId, active, activeTab, siteId }) => {
  // Table state management
  const { sortDirection: sortActiveDirection, sortMetric: sortActiveMetric } = useColumnState({
    defaultSortMetric: EventMetric.START,
    defaultSortDirection: SortDirection.DESC,
  });

  const { data: asset, isLoading, isFetching } = useAssetRealTimeData({
    assetId,
    sortDirection: sortActiveDirection,
    sortMetric: sortActiveMetric,
  });

  if (isLoading)
    return (
      <SiteLoader className={!active && 'hidden'}>
        <Loader />
      </SiteLoader>
    );

  return (
    <TurbineContentWrapper className={!active && 'hidden'}>
      {activeTab === MobileAssetTab.ALARM ?
        <AssetActiveAlarmInfo asset={asset} siteId={siteId} /> :
        <AssetRealtimeInfo asset={asset} />}
    </TurbineContentWrapper>
  );
};

AssetDetails.propTypes = {
  onRowSelect: PropTypes.func,
  theme: PropTypes.instanceOf(Object),
  assets: PropTypes.arrayOf(PropTypes.instanceOf(Object)).isRequired,
  isLoading: PropTypes.bool,
  active: PropTypes.bool,
  assetId: PropTypes.string,
  activeTab: PropTypes.string,
  siteId: PropTypes.string,
};
AssetDetails.defaultProps = {
  assets: [],
  isLoading: true,
  assetId: '',
};
export default withTheme(AssetDetails);
